var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSellBlog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 517,
    height: 517,
    viewBox: "0 0 517 517",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M516 1H1V516H516V1Z",
    fill: "#90A8ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M515.995 151H423.505C423.505 151 416.45 139.19 422.358 132.631C428.265 126.072 436.627 129.808 439.237 132.884C441.851 135.96 443.837 137.325 445.614 135.357C447.391 133.389 449.792 130.261 455.384 132.075C460.977 133.894 465.054 140.046 468.448 139.541C471.842 139.036 472.626 135.254 478.325 134.594C484.025 133.935 485.642 137.974 487.419 139.994C489.196 142.014 490.604 138.582 492.958 136.511C495.311 134.44 500.903 136.563 503.566 138.881C506.229 141.2 507.382 143.168 509.42 141.504C511.459 139.84 516 140.494 516 140.494V151",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M515.995 151H423.505C423.505 151 416.45 139.19 422.358 132.631C428.265 126.072 436.627 129.808 439.237 132.884C441.851 135.96 443.837 137.325 445.614 135.357C447.391 133.389 449.792 130.261 455.384 132.075C460.977 133.894 465.054 140.046 468.448 139.541C471.842 139.036 472.626 135.254 478.325 134.594C484.025 133.935 485.642 137.974 487.419 139.994C489.196 142.014 490.604 138.582 492.958 136.511C495.311 134.44 500.903 136.563 503.566 138.881C506.229 141.2 507.382 143.168 509.42 141.504C511.459 139.84 516 140.494 516 140.494V151",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M254.394 116H333C333 116 329.77 111.752 324.794 110.662C319.813 109.578 318.577 111.782 316.589 110.662C314.595 109.542 311.334 107.832 308.93 109.114C306.526 110.395 304.67 111.187 302.992 109.87C301.308 108.554 297.563 105.325 292.587 105.557C287.606 105.789 286.649 110.168 284.071 108.983C281.494 107.797 281.494 103.418 276.308 103.019C271.121 102.626 268.444 108.357 266.624 107.731C264.804 107.106 263.052 103.317 258.45 103.287C253.842 103.251 253.5 108.423 254.394 116Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 132C1 132 63.4694 132 63.936 132C64.3974 132 62.3422 126.66 58.4414 126.66C54.5407 126.66 55.1017 127.122 52.281 124.966C49.4551 122.81 44.8361 122.092 41.2919 123.681C37.7476 125.276 36.2062 126.403 33.9989 124.604C31.7917 122.805 30.1978 120.03 25.065 120.544C19.9322 121.058 18.6477 123.985 16.1835 122.139C13.7193 120.287 9.331 115 1 115V132Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M424.134 249.728C424.134 249.728 427.098 246.332 431.991 244.794C436.883 243.256 438.18 245.644 441.096 241.929C444.007 238.213 448.119 238.43 452.071 238.695C456.024 238.961 456.337 234.612 460.343 233.393C464.348 232.175 466.638 236.578 469.342 232.597C472.046 228.622 472.412 226.818 476.104 228.037C479.796 229.255 481.773 229.575 483.233 226.873C484.689 224.17 487.186 223 489.683 224.327C492.179 225.654 493.428 223.163 497.019 221.305C500.61 219.447 502.586 223.531 505.083 222.789C507.58 222.047 509.716 219.87 511.639 219.182C513.562 218.494 515.32 219.87 516 221.408V276L404 264.897L424.134 249.728Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 225.132C1 225.132 3.73003 217.904 8.39648 217.904C13.0629 217.904 15.9094 222.807 15.9094 222.807C15.9094 222.807 19.0203 216.712 24.3005 216.712C29.5807 216.712 33.4694 223.577 33.4694 223.577C33.4694 223.577 36.5804 216.712 42.1198 216.712C47.6592 216.712 50.4633 223.066 50.4633 223.066C50.4633 223.066 54.1404 216.712 58.4418 216.712C62.7432 216.712 66.4732 223.788 66.4732 223.788C66.4732 223.788 70.891 215.779 77.933 221.305C84.975 226.835 181.817 223.999 181.817 223.999C181.817 223.999 184.97 218.141 189.737 218.141C194.504 218.141 197.615 222.48 197.615 222.48C197.615 222.48 201.277 217.593 207.287 217.593C213.297 217.593 216.546 223.171 216.546 223.171C216.546 223.171 221 216.517 227.27 216.022C233.54 215.531 298.653 223.582 298.653 223.582C298.653 223.582 308.081 221.979 314.197 224.458C320.313 226.936 320.62 227.969 324.303 227.4C327.985 226.83 334.043 225.644 339.122 228.38C344.201 231.117 345.132 233.748 349.275 233.748C353.418 233.748 361.814 235.451 365.078 238.293C368.343 241.135 369.48 242.01 373.369 241.44C377.253 240.871 383.056 240.924 387.67 243.765C392.284 246.607 393.992 246.191 396.58 245.316C399.172 244.44 404.405 243.407 408.135 245.21C411.865 247.013 413.314 248.722 415.129 247.947C416.944 247.172 423.007 246.655 425.753 248.669C428.499 250.683 428.345 251.458 430.985 250.578C433.626 249.702 435.805 250.114 436.89 251.664C437.98 253.214 439.17 253.214 441.763 252.697C444.355 252.18 446.895 255.281 448.498 255.381C450.106 255.486 452.799 257.084 453.99 259.304C455.18 261.523 352.783 275.485 352.783 275.485L1 281V225.132Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 303.923V258H76.6054H90.4302H99.7579H115.757H133.174H160.724H182.717H224.546H297.21H516V516H1V384.243V313.305V303.923Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M488 288H495",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M484 276H488",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M456 286L459 285",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M370 280L373 286",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M379 273V284",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M387 269L385 281",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M433 296H437",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M403 337L401 353",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M395 338V354",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M387 346C387 346 388.473 349.938 389 351L387 346Z",
    fill: "#FFC900"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M387 346C387 346 388.473 349.938 389 351",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M374 359C374 359 377.311 359 379 359H374Z",
    fill: "#FFC900"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M374 359C374 359 377.311 359 379 359",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M391 367C391 367 391.906 367 392.955 367C394.004 367 395 367 395 367",
    fill: "#FFC900"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M391 367C391 367 391.906 367 392.955 367C394.004 367 395 367 395 367",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M462 392H466",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M460 427H465",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M450 437H463",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M468 461H471",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M476 471H478",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M417 463C417 463 418.085 463 420 463H417Z",
    fill: "#FFC900"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M417 463C417 463 418.085 463 420 463",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M429 435L425 449",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M420 435V451",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M412 442C412 442 413.343 445.078 414 446L412 442Z",
    fill: "#FFC900"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M412 442C412 442 413.343 445.078 414 446",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M399 456C399 456 401.788 456 404 456H399Z",
    fill: "#FFC900"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M399 456C399 456 401.788 456 404 456",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M346 446H350",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M316 404L321 403",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M302 411H304",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M324 458H329",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M269 451L266 465",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M261 443V461",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M248 450L255 466",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M174 390C174 390 172.491 390 172 390H174Z",
    fill: "#FFC900"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M174 390C174 390 172.491 390 172 390",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M157 398H162",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M147 404C147 404 148.725 404 149.595 404C150.458 404 151 404 151 404",
    fill: "#FFC900"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M147 404C147 404 148.725 404 149.595 404C150.458 404 151 404 151 404",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M62 483L60 497",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M52 476L54 491",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M43 486L50 499",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M25 460H27",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M46 442H48",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M21 440C21 440 21.7838 440 22 440H21Z",
    fill: "#FFC900"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M21 440C21 440 21.7838 440 22 440",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M143 473H138",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M136 458H140",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M120 463H124",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M105 412L99 434",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M93 412V429",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M80 420L88 436",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M85 390.923C85 390.923 86.8592 391.396 88 390L85 390.923Z",
    fill: "#FFC900"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M85 390.923C85 390.923 86.8592 391.396 88 390",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M59 395C59 395 60.2256 395 61 395H59Z",
    fill: "#FFC900"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M59 395C59 395 60.2256 395 61 395",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1 385H4",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M22 334C22 334 23.0245 334 24 334H22Z",
    fill: "#FFC900"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M22 334C22 334 23.0245 334 24 334",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M39 320C39 320 39.3619 320 41 320H39Z",
    fill: "#FFC900"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M39 320C39 320 39.3619 320 41 320",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M37 278L36 288",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M27 274L31 287",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M22 280L27 289",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M477.279 300.765C477.279 300.765 480.428 299.796 484.145 300.039C487.858 300.283 491.07 301.496 489.662 302.948C488.254 304.404 479.928 304.202 477.56 303.232C475.198 302.259 475.865 301.104 477.279 300.765Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M229.63 463.812C229.63 463.812 231.488 463.09 233.252 463.004C235.015 462.912 237.66 464.412 236.849 467.981C236.039 471.551 230.256 469.628 228.796 467.981C227.331 466.328 228.052 464.296 229.63 463.812Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M167.232 432.908C167.232 432.908 171.621 431.337 175.417 431.032C179.212 430.727 181.946 432.638 180.692 434.666C179.438 436.694 169.04 437.69 166.272 436.465C163.505 435.246 165.922 433.335 167.232 432.908Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4711 410.795C34.4711 410.795 39.1047 408.05 43.8878 409.349C48.6708 410.647 49.2039 414.186 45.8907 415.433C42.5724 416.681 34.6704 415.683 33.4996 414.237C32.3287 412.791 33.4498 411.304 34.4711 410.795Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0394 287.564C77.0394 287.564 63.4557 285.412 63.0124 289.517C62.5691 293.622 74.1465 294.721 77.5964 293.571C81.052 292.42 77.0394 287.564 77.0394 287.564Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 308.639C12.0647 311.065 6.03237 311.806 1 312V304C5.22806 304.524 11.9288 305.793 11.9995 308.639Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M226 329L223 348",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M230 336L225 350",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M217 319L222 347",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M209 307L215 344",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M56 316L62 341",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M52 332L60 343",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M56 346L49 341",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M200 379C187.084 376.207 174.401 372.52 164.655 368.199C162.962 367.442 161.353 366.675 159.845 365.882C159.475 365.686 159.11 365.491 158.755 365.3C156.517 364.068 154.533 362.803 152.85 361.492C143.522 354.24 141.66 340.461 141.66 340.461C138.448 351.96 130.569 360.561 108.6 368.918C86.6315 377.276 74.2978 376.101 74.2978 376.101C74.2978 376.101 81.8641 369.161 89.113 360.873C96.2508 352.711 101.193 342.365 101.346 342.047C98.616 345.004 95.637 347.644 93.0549 349.135C88.6792 351.653 58.5883 363.158 56.1596 364.084C56.1385 364.094 56.1226 364.099 56.1067 364.105C56.0803 364.115 56.0591 364.131 56.0274 364.136C56.0168 364.142 56.0115 364.147 56.0009 364.147C54.0749 364.962 52.0114 365.707 49.8367 366.369C39.265 369.579 26 368.855 26 368.855C30.561 367.818 41.0269 362.534 55.1226 349.273C69.2182 336.012 74.9486 324.687 74.9486 324.687L86.5521 1H131.807C131.807 1 130.495 218.04 130.495 237.378C130.495 256.717 140.443 276.33 149.014 293.151C157.581 309.977 156.475 321.085 167.946 343.603C179.412 366.12 200 379 200 379Z",
    fill: "#98282A"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M224.443 384C224.443 384 218.256 383.069 199.172 378.923C199.172 378.923 178.683 366.046 167.272 343.533C155.855 321.025 156.956 309.914 148.43 293.092C139.905 276.274 130 256.665 130 237.33C130 217.996 131.306 1 131.306 1H175.792C175.792 1 183.08 269.235 183.08 274.513C183.08 279.796 183.801 307.867 196.487 326.927C209.172 345.987 232.932 352.38 232.932 352.38C232.479 355.347 232.521 358.219 233 360.905C232.663 360.821 217.597 357.14 205.67 353.861C193.601 350.545 186.381 344.955 186.381 344.955C191.026 363.491 224.443 384 224.443 384Z",
    fill: "#98282A"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M165 357L163 368",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M161 350L159 366",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M154 344L158 365",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M124 9L116 200",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M200 379C200 379 179.265 366.12 167.712 343.603C156.159 321.086 157.273 309.973 148.646 293.152C140.018 276.332 130 256.713 130 237.375C130 218.037 131.322 1 131.322 1",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M160 255C160 255 161.726 278.594 164.539 294.677C167.346 310.755 173.825 324.956 176.417 331.22C179.009 337.484 187 345 187 345",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M152 1L162 236",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M140 340.391C140 340.391 141.878 354.168 151.25 361.418C160.628 368.669 179.378 374.782 198.654 378.923C217.926 383.064 224.181 384 224.181 384C224.181 384 190.426 363.491 185.739 344.95C185.739 344.95 193.032 350.545 205.223 353.856C217.415 357.172 232.835 360.9 232.835 360.9L237 358.102L232.766 352.38C232.766 352.38 208.766 345.987 195.952 326.927C183.138 307.867 182.41 279.796 182.41 274.513C182.41 269.23 175.048 1 175.048 1",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9084 342.002C99.9084 342.002 94.9456 352.82 87.7357 361.322C80.5257 369.824 73 376.942 73 376.942C73 376.942 85.2675 378.146 107.118 369.574C128.969 361.002 136.806 352.18 140 340.385C140 340.385 137.837 321.575 140 305",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M110 291C110 291 110 312.367 110 320.114C110 327.862 105.835 335.92 105 337",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M55 364C55 364 88.1169 351.554 92.7601 348.918C97.4087 346.282 103.325 340.038 106.841 334.76C110.357 329.483 120.22 310.059 121.628 304.229C123.035 298.399 120.08 280.634 118.953 273.278C117.826 265.923 114.164 243.576 114.585 234",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M90 256L86 329",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M102 1L90 238",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M86.373 1L74.7995 324.752C74.7995 324.752 69.0814 336.08 55.0339 349.344C40.9864 362.607 30.5471 367.893 26 368.93C26 368.93 39.2246 369.655 49.7641 366.443C60.3037 363.232 68.0528 358.052 71.5659 352.973C75.0791 347.894 85.7189 331.313 91.6112 319.191C97.5034 307.07 98.6375 294.944 98.6375 293.388C98.6375 291.833 110 53.1827 110 53.1827",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M284 309.304C279.546 311.107 278.097 316.907 278.097 316.907C278.097 316.907 276.029 314.937 275.331 313.713H275.326C276.024 307.564 273.226 301.545 273.226 301.545L269.037 315L268.666 314.453C268.666 314.453 263.023 305.678 261.88 304.093C260.743 302.515 255.665 300.727 255.665 300.727L249.556 310.32L259.447 323.639C259.447 323.639 262.97 328.23 266.233 332.164C267.963 334.243 270.354 335.265 272.57 335.572V336.823C270.015 336.588 267.63 336.979 265.635 338C262.435 339.631 256.384 344.191 251.545 348H234C234 348 237.798 337.724 239.596 326.974C241.394 316.219 240.702 313.431 242.569 305.605C244.182 298.841 246.361 295.282 249.561 294C251.635 294.552 253.782 294.98 255.998 295.271C257.188 296.616 259.362 298.492 262.874 299.555C268.27 301.186 270.972 298.56 271.089 295.094C272.057 294.938 273.004 294.761 273.934 294.547C275.415 297.121 279.673 304.208 284 309.304Z",
    fill: "#F1F333"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M273 336V337",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M234 348C234 348 237.797 337.674 239.596 326.872C241.388 316.07 240.701 313.268 242.563 305.403C244.429 297.539 247.053 293.983 251.125 293.303C255.197 292.622 273.364 293.303 273.364 293.303C273.364 293.303 278.627 302.754 284 309.116",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M285 341.667C285 341.667 294.015 335.998 303.477 337.156C312.934 338.314 317.728 353.15 306.435 375.801C303.532 381.62 285.418 364.368 285.418 364.368L285 341.667Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M303.153 375.537C303.153 375.537 311.577 372.255 317.099 370.059C322.621 367.863 328.945 369.23 329 372.798C329.054 376.366 322.149 382.841 311.789 385.804C301.428 388.767 294.74 385.647 296.199 382.706C297.658 379.766 303.153 375.537 303.153 375.537Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M328 373C328 373 322.765 378.659 318 381C318 381 327.053 376.358 328 373Z",
    fill: "#FECB00"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M291 351L295 348",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M244.431 354.687C244.431 354.687 259.911 341.377 265.785 338.282C271.659 335.181 280.921 337.721 287.758 345.746C294.601 353.776 303.169 372.505 304 376.167C304 376.167 302.132 380.956 297.644 383C297.644 383 289.42 380.255 283.339 372.861C277.259 365.468 275.808 358.284 275.808 358.284C275.808 358.284 269.453 379.408 254.804 379.764C240.155 380.115 229.375 365.397 234.143 348.642H251.755",
    fill: "#F1F333"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M244.431 354.687C244.431 354.687 259.911 341.377 265.785 338.282C271.659 335.181 280.921 337.721 287.758 345.746C294.601 353.776 303.169 372.505 304 376.167C304 376.167 302.132 380.956 297.644 383C297.644 383 289.42 380.255 283.339 372.861C277.259 365.468 275.808 358.284 275.808 358.284C275.808 358.284 269.453 379.408 254.804 379.764C240.155 380.115 229.375 365.397 234.143 348.642H251.755",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M255 293.672C255 293.672 257.094 298.37 262.908 300.428C268.721 302.486 271.357 298.664 270.961 294.14C270.565 289.615 255 293.672 255 293.672Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M292.3 233.715C299.062 229.079 303.45 222.549 303.951 215.083C305.013 199.415 288.591 185.552 267.279 184.12C245.967 182.688 227.831 194.226 226.769 209.894C226.262 217.361 229.731 224.423 235.805 229.915C240.849 234.481 240.315 242.437 234.7 246.285C227.938 250.921 223.55 257.451 223.049 264.917C221.987 280.585 238.409 294.448 259.721 295.88C281.033 297.312 299.169 285.774 300.231 270.106C300.738 262.639 297.269 255.577 291.195 250.085C286.151 245.524 286.685 237.563 292.3 233.715Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M286 283C287.105 283 288 282.105 288 281C288 279.895 287.105 279 286 279C284.895 279 284 279.895 284 281C284 282.105 284.895 283 286 283Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M269.5 282C270.881 282 272 281.328 272 280.5C272 279.672 270.881 279 269.5 279C268.119 279 267 279.672 267 280.5C267 281.328 268.119 282 269.5 282Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M283.585 321C283.585 321 280.543 318.738 279 316.841C279 316.841 280.351 310.854 284.502 309C284.502 309 287.908 312.649 288.894 313.208C289.885 313.772 283.585 321 283.585 321Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M273.484 301C273.484 301 279.898 313.543 272.245 321.183C264.592 328.824 266.125 318.498 266.125 318.498L267.304 319.036",
    fill: "#F1F333"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M273.484 301C273.484 301 279.898 313.543 272.245 321.183C264.592 328.824 266.125 318.498 266.125 318.498L267.304 319.036",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M293.006 318.209C293.006 318.209 295.362 320.498 299.958 321.25C299.958 321.25 296.524 321.181 294.616 321.008C292.709 320.834 294.72 322.281 296.315 322.76C297.915 323.238 298.801 323.517 298.801 323.517C298.801 323.517 295.669 323.722 294.611 323.828C293.558 323.933 295.726 325.406 296.477 325.579C297.233 325.753 298.556 326.542 298.556 326.542C298.556 326.542 295.085 326.542 294.199 326.542C293.313 326.542 295.356 329.425 301.96 328.946C308.563 328.468 308.797 323.896 307.13 320.498C305.462 317.099 300.5 315 300.5 315C300.5 315 292.922 315.989 293.001 316.247C293.079 316.505 293.006 318.209 293.006 318.209Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M301.503 313C301.503 313 303.359 313.926 303.813 315.398C304.268 316.87 303.846 318.715 303.057 318.966C302.268 319.217 300.64 318.002 300 317.912",
    fill: "#F1F333"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M301.503 313C301.503 313 303.359 313.926 303.813 315.398C304.268 316.87 303.846 318.715 303.057 318.966C302.268 319.217 300.64 318.002 300 317.912",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M286.93 314.8L290.148 301H304L299.054 317.794C299.054 317.794 296.579 317.498 294.947 317.498C293.315 317.498 290.794 319.494 290.794 319.494L285 320L286.93 314.8Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M293 301L289.162 318.008L286 319L290.523 301H293Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M286.93 314.8L290.148 301H304L299.054 317.794C299.054 317.794 296.579 317.498 294.947 317.498C293.315 317.498 290.794 319.494 290.794 319.494L285 320L286.93 314.8Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M269.229 313.15L275.622 323.369L283.622 320.514C283.622 320.514 283.569 315.573 284.248 314.361C284.927 313.15 287.469 313.812 287.469 313.812L286.588 317.766C286.588 317.766 286.641 318.921 287.161 318.59C287.681 318.259 288.668 317.16 289.808 316.117C290.949 315.074 292.716 315.679 292.196 317.104C291.676 318.529 290.843 321.17 290.843 321.17C290.843 321.17 292.196 319.521 293.49 319.415C294.79 319.303 292.243 322.657 292.09 323.369C291.936 324.081 293.23 323.257 294.222 322.489C295.209 321.72 295.103 323.644 294.742 325.287C294.376 326.936 293.549 328.692 292.249 329.354C290.949 330.016 280.402 333.858 278.062 335.232C275.723 336.606 270.062 336.438 266.788 332.209C263.515 327.98 259.981 323.038 259.981 323.038L259 312L269.229 313.15Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M256.074 301C256.074 301 261.122 302.794 262.253 304.379C263.384 305.969 269 314.778 269 314.778C269 314.778 262.048 318.11 259.834 324L250 310.63",
    fill: "#F1F333"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M256.074 301C256.074 301 261.122 302.794 262.253 304.379C263.384 305.969 269 314.778 269 314.778C269 314.778 262.048 318.11 259.834 324L250 310.63",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M516 64H395.551C395.551 64 386.045 54.3016 387.079 48.3979C388.113 42.4941 399.064 43.4225 403.748 46.0364C408.433 48.6502 412.495 52.0687 414.014 49.5786C415.528 47.0933 420.592 42.894 428.858 44.6366C437.125 46.3792 440.949 52.9066 443.46 51.226C445.977 49.5453 447.665 45.6317 456.237 46.6553C464.814 47.6789 469.288 52.9971 469.288 52.9971C469.288 52.9971 472.078 48.8644 479.205 48.8644C486.332 48.8644 490.674 54.3969 492.499 53.3732C494.324 52.3496 495.875 49.4263 501.625 49.7691C507.375 50.1119 510.888 54.8063 510.888 54.8063C510.888 54.8063 513.009 52.2877 515.995 52.7257V64H516Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M516 1H1V516H516V1Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M276 313C276.757 314.15 279 316 279 316",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellBlog);
export default __webpack_public_path__ + "static/media/SellBlog.bdaf694f7754d371350f1850ddd1cfcb.svg";
export { ForwardRef as ReactComponent };